import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { useThemeContext } from '../../../components/ThemeProvider';
import Lottie from 'lottie-react';
import { useCommonTranslation } from '../../../hooks';

const ErrorLayout = ({ code, title, message, action }) => {
  const { primaryColor } = useThemeContext();
  const { t } = useCommonTranslation();
  const [anim, setAnim] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const tryPaths = ['/images/lottie/errors.json', '/images/lottie/errror.json'];
        for (const p of tryPaths) {
          try {
            const res = await fetch(p);
            if (res.ok) {
              const json = await res.json();
              if (!cancelled) setAnim(json);
              return;
            }
          } catch (_) { /* try next */ }
        }
      } catch (e) {
        // ignore
      }
    };
    load();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="min-h-[60vh] w-full flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25 }}
        className="max-w-xl w-full text-center bg-white dark:bg-gray-900/60 backdrop-blur rounded-2xl shadow-lg border border-gray-200/60 dark:border-gray-800/60 p-8"
      >
        {anim && (
          <motion.div initial={{ scale: 0.96, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.25 }} className="mx-auto mb-4 w-40 h-40">
            <Lottie animationData={anim} loop autoplay style={{ width: '100%', height: '100%' }} />
          </motion.div>
        )}
        <div className="text-7xl font-extrabold tracking-tight" style={{ color: primaryColor }}>{code}</div>
        <h1 className="mt-4 text-2xl font-bold text-gray-900 dark:text-gray-100">{title}</h1>
        <p className="mt-2 text-gray-600 dark:text-gray-300">{message}</p>
        <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          {t('errorPages.layout.coffeeBreak')} {code === 404 ? t('errorPages.layout.linkWrong') : t('errorPages.layout.somethingWrong')} {t('errorPages.layout.backOnTrack')}
        </p>
        {action && (
          <div className="mt-6">{action}</div>
        )}
      </motion.div>
    </div>
  );
};

ErrorLayout.propTypes = {
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  action: PropTypes.node,
};

export default ErrorLayout;
